const POPUP_TYPES = {
  POSITIVE: 'positive',
  NEUTRAL: 'neutral',
  NEGATIVE: 'negative',
  DEFAULT: 'default'
};

export default POPUP_TYPES;
